import { useAuthStore } from '../stores/authStore';
import type {
  ImpersonationSession,
  UserContext,
  ImpersonatedContext,
  RoleName,
} from '../types/auth.types';

export function useImpersonation(): {
  isImpersonating: boolean;
  currentSession: ImpersonationSession | null;
  originalUser: UserContext | null;
  impersonatedContext: ImpersonatedContext | null;
  effectiveCompanyId: string | undefined;
  effectiveRoles: RoleName[] | string[];
  startImpersonation: (session: ImpersonationSession, context: ImpersonatedContext) => void;
  endImpersonation: () => void;
} {
  const impersonation = useAuthStore((state) => state.impersonation);
  const user = useAuthStore((state) => state.user);
  const startImpersonationFn = useAuthStore((state) => state.startImpersonation);
  const endImpersonationFn = useAuthStore((state) => state.endImpersonation);

  const effectiveCompanyId = impersonation.isImpersonating
    ? impersonation.impersonatedContext?.companyId
    : user?.companyId;

  const effectiveRoles = impersonation.isImpersonating
    ? (impersonation.impersonatedContext?.effectiveRoles ?? [])
    : (user?.roles ?? []);

  return {
    isImpersonating: impersonation.isImpersonating,
    currentSession: impersonation.currentSession,
    originalUser: impersonation.originalUser,
    impersonatedContext: impersonation.impersonatedContext,
    effectiveCompanyId,
    effectiveRoles,
    startImpersonation: startImpersonationFn,
    endImpersonation: endImpersonationFn,
  };
}
